/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.zoom.integration.chirp.rpc.RecordingRpc
 */

export const getAuthRecordingFileUrlRpc = {
  serviceName: 'com.hubspot.zoom.integration.chirp.rpc.RecordingRpc',
  rpcName: 'getAuthRecordingFileUrl',
  auth: 'app',
  fingerprint: 'joODMZD98yAR6jOGCwxEYZfgnl0pZPyz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};